import { render, staticRenderFns } from "./GetAllMastersList.vue?vue&type=template&id=6f2b9206"
import script from "./GetAllMastersList.vue?vue&type=script&lang=js"
export * from "./GetAllMastersList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports